/* eslint-disable @typescript-eslint/ban-types */
import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'


const basePath = '/our-clients'

const OurClientsEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) =>
  ({
    fetchOurClients: builder.query<any, any>({
      query: () => `${basePath}`,
      providesTags:['our-clients']
    }),

    createOurClient: builder.mutation<any, any>({
      query: (body) => ({
        url: `${basePath}`,
        method: 'post',
        body,
      }),
      invalidatesTags: ['our-clients']
    }),

    deleteOurClient: builder.mutation<any, any>({
      query: (id) => ({
        url: `${basePath}?id=${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['our-clients'],
    }),

    updateOurClient: builder.mutation<any, any>({
      query: ({id, body}) => ({
        url: `${basePath}/${id}`,
        method: 'put',
        body,
      }),
      invalidatesTags: ['our-clients'],
    }),

    uploadClientImage: builder.mutation<any, any>({
      query: (body) => ({
        url: `${basePath}/upload`,
        method: 'post',
        body,
      }),
      invalidatesTags: ['our-clients'],
    }),
    deleteClientImage: builder.mutation<any, any>({
      query: (id) => ({     
        url: `${basePath}/images?id=${id}`,
        method: 'delete',
      }),   
      invalidatesTags: ['our-clients'],
    }), 
  })

export default OurClientsEndpoints
